import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShieldAlt,
  faBolt,
  faSyncAlt,
  faTools,
  faHeadset,
} from '@fortawesome/free-solid-svg-icons';
import { faWordpress } from '@fortawesome/free-brands-svg-icons';
import './style.css';

const benefitsSection = [
  {
    title: 'Optimized for WordPress',
    icon: faWordpress,
    description:
      'Easily and quickly build your website with maximum performance and zero coding required.',
  },
  {
    title: '24/7 Security Monitoring',
    icon: faShieldAlt,
    description:
      'We apply advanced security protocols specifically designed for WordPress hosting.',
  },
  {
    title: 'Fast & Reliable Hosting',
    icon: faBolt,
    description:
      'Experience noticeable improvements in website speed and performance.',
  },
  {
    title: 'Automatic Backups',
    icon: faSyncAlt,
    description:
      'Sleep easy knowing your site is always backed up and recoverable anytime.',
  },
  {
    title: 'Developer Tools',
    icon: faTools,
    description:
      'Integrated tools to boost WordPress site development and streamline your workflow.',
  },
  {
    title: 'Expert Support',
    icon: faHeadset,
    description:
      'Dedicated specialists ready to help, whenever you need us.',
  },
];

function BenefitsSection() {
  return (
    <section className="benefits-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="benefits-title">
            Everything You Need for a Flawless Website
          </h2>
          <div className="benefits-lead">
            High performance, real support, built for WordPress.
          </div>
        </div>
        <Row className="text-center">
          {benefitsSection.map((feature, index) => (
            <Col key={index} xs="12" sm="6" md="4" className="mb-4">
              <div className="benefits-card" tabIndex={0}>
                <div
                  className="benefits-icon"
                  title={feature.description}
                  aria-label={feature.description}
                >
                  <FontAwesomeIcon
                    icon={feature.icon}
                    size="3x"
                  />
                </div>
                <h5 className="benefits-card-title">
                  {feature.title}
                </h5>
                <div className="benefits-card-desc">
                  {feature.description}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default BenefitsSection;
